import React, { useState, useMemo } from 'react'
import Layout from '@/components/Layout'
import Heading from '@/components/ui/Heading'
import SlideIn from '@/components/animations/SlideIn'
import { useProjects } from '@/lib/hooks'
import ProjectFilters from '@/components/projects/ProjectFilters'
import ProjectGrid from '@/components/projects/ProjectGrid'

const ProjectsPage = () => {
  const [selectedType, setSelectedType] = useState<string | null>(null)
  const [projectsState, refetchProjects] = useProjects()

  const projects = projectsState.data || []
  const isLoading = projectsState.isLoading

  // Extract unique project types for filtering
  const projectTypes = useMemo(() => {
    const types = projects.map(project => project.projectType)
    return Array.from(new Set(types)).sort()
  }, [projects])

  return (
    <section className="py-12">
      <SlideIn direction="down" className="text-center mb-12">
        <Heading level={1} gradient={true}>
          My Projects
        </Heading>
        <p className="text-xl mt-4 max-w-3xl mx-auto">
          Explore my blockchain development work, from smart contracts to decentralized applications
          and web3 integrations.
        </p>
      </SlideIn>

      {isLoading ? (
        <div className="flex justify-center py-20">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
        </div>
      ) : projectsState.error ? (
        <div className="flex flex-col items-center py-20">
          <p className="text-red-500 mb-4">Error loading projects: {projectsState.error.message}</p>
          <button
            onClick={() => refetchProjects()}
            className="px-4 py-2 bg-primary text-white rounded hover:bg-primary/80"
          >
            Try Again
          </button>
        </div>
      ) : (
        <>
          {/* Filters */}
          <ProjectFilters
            projectTypes={projectTypes}
            selectedType={selectedType}
            onTypeChange={setSelectedType}
          />

          {/* Projects Grid */}
          {selectedType && projects.length > 0 && (
            <div className="mb-6 flex justify-center">
              <button onClick={() => setSelectedType(null)} className="btn btn-outline">
                Clear Filter
              </button>
            </div>
          )}

          <ProjectGrid projects={projects} selectedType={selectedType} />
        </>
      )}
    </section>
  )
}

export default ProjectsPage
